import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ZalamoObject } from '../../../../../graphql';
import { UserWallEvent } from '../../../../../../../../graphql/libs/viewer-wall/types';
import { UserWallEventType } from '../../graphql';
import { ParseJson } from 'ZalamoLibrary/src/lib/core/decorators/ParseJson';

@Component({
    selector: 'app-privateesion-visited-by-client',
    templateUrl: './privateesion-visited-by-client.component.html',
    styleUrls: ['./privateesion-visited-by-client.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrivateesionVisitedByClientComponent implements OnInit {
  ob: ZalamoObject = ZalamoObject.OrganizationClient;

  private _details: UserWallEvent[UserWallEventType.PrivateSessionVisitedByClient];

  get details(): UserWallEvent[UserWallEventType.PrivateSessionVisitedByClient] {
    return this._details;
  }

  @Input()
  @ParseJson
  set details(
    value: UserWallEvent[UserWallEventType.PrivateSessionVisitedByClient]
  ) {
    this._details = value;
  }

  constructor() {}

  ngOnInit(): void {}
}
